module.exports = __webpack_public_path__ + "img/total-students.b5f8f92f.svg";